var map = {
	"./1.png": 6314,
	"./2.png": 5297,
	"./3.png": 6232,
	"./4.png": 5847,
	"./5.png": 2206,
	"./5.svg": 8550,
	"./6.png": 4629,
	"./7.png": 7116,
	"./8.png": 7419,
	"./9.png": 3762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1795;